/**
 * Members Report Page
 */
import React from 'react';

const MembersReport = () => {
  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Members Report</h1>
      <p className="text-gray-600 dark:text-gray-400 mt-2">Detailed members report</p>
    </div>
  );
};

export default MembersReport;
